import { render, staticRenderFns } from "./knockOffPromo.vue?vue&type=template&id=6b2b2449&lang=pug"
import script from "./knockOffPromo.vue?vue&type=script&lang=js"
export * from "./knockOffPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports